export default __webpack_public_path__ + "static/media/axaLogo.136d43c8.svg";